// src/pages/Admin.jsx
import React, { useState } from 'react';
import { Tabs, Tab, Box, Paper } from '@mui/material';
import UsersList from '../../components/Admin/UsersList';
import GroupsList from '../../components/Admin/GroupsList';
import AssignedProjectsList from '../../components/Admin/AssignedProjectsList';
import SparrowUsersList from '../../components/Admin/SparrowUsersList';

export default function Admin() {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <div>
      <Paper sx={{ width: '100%', marginTop: 2, padding: 2 }}>
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          sx={{
            '& .MuiTab-root': {
              minWidth: '160px',
              fontSize: '16px',
              padding: '12px 20px',
              textTransform: 'none',
            },
            '& .MuiTabs-indicator': {
              height: '4px',
              borderRadius: '2px',
            },
          }}
        >
          <Tab label="Users" />
          <Tab label="Groups" />
          <Tab label="Project Assignments" />
          <Tab label="Sparrow Assignments" />
        </Tabs>

        <Box sx={{ marginTop: 2 }}>
          {selectedTab === 0 && <UsersList />}
          {selectedTab === 1 && <GroupsList />}
          {selectedTab === 2 && <AssignedProjectsList />}
          {selectedTab === 3 && <SparrowUsersList />}
        </Box>
      </Paper>
    </div>
  );
}
